import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

interface BlurredMapOverlayProps {
  address: string;
  city: string;
  state: string;
  zipCode: string;
}

export const BlurredMapOverlay = ({
  address,
  city,
  state,
  zipCode
}: BlurredMapOverlayProps) => {
  return (
    <Card>
      <CardContent className="p-0 relative overflow-hidden">
        {/* Blurred placeholder with gradient */}
        <div className="h-[300px] bg-gradient-to-br from-muted/50 to-muted blur-sm" />
        
        {/* Overlay with signup prompt */}
        <div className="absolute inset-0 flex items-center justify-center bg-background/90 backdrop-blur-sm">
          <div className="text-center p-6 max-w-sm">
            <MapPin className="h-12 w-12 mx-auto mb-4 text-godyspo-gold" />
            <h3 className="text-lg font-semibold mb-2">Sign Up to View Location</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Access exact property location, interactive map, and Zillow details with a free account
            </p>
            <Button asChild className="w-full">
              <Link to="/buyer/register">Create Free Account</Link>
            </Button>
            <p className="text-xs text-muted-foreground mt-2">
              Free for buyers • No credit card required
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
